import { BNGoogleTagManager, EventAction, EventLabel } from "../../Helpers/GoogleTagManager/BNGoogleTagManager";

import { NavigateFunction } from "react-router";
import React, { useMemo } from "react";
import { SxProps, Theme, useTheme } from "@mui/material/styles";
import { IconButton, IconButtonProps } from "@mui/material";
import BNBox from "../BNBox/BNBox";
import { IconSrcToMuiMapper } from "../../Helpers/IconSrcToMuiMapper/IconSrcToMuiMapper";
import { UiElementClickEvent } from "../../Helpers/GoogleTagManager/UiElementClickEvent";
import { sxEnsureArray } from "../../Helpers/sxMerge";
import { BNStack } from "../components";
import { resolveUrl } from "../../Helpers/helpers";

export interface HeaderButtonProps {
  text?: string;
  link?: string;
  logoSrc?: string;
  isSpa?: boolean;
  buttonId?: string;
  navigate?: NavigateFunction;
  onClick?: (event: any) => void;
  hasPopup?: boolean;
  ariaOwns?: any;
  ariaLabel?: string;
  dataUit?: string;
  dataCmsTargetKey?: string;
  icon?: any;
  iconProps?: any;
  hidden?: { mdDown?: boolean; mdUp?: boolean };
  iconButtonSx?: SxProps<Theme>;
  clickHandlerOverride?: IconButtonProps["onClick"] | null;
  popoverTarget?: string;
  hrefLang?: string;
}

const HeaderButton: React.FC<HeaderButtonProps> = (props) => {
  const theme = useTheme();
  const navigate = props.navigate;
  const {
    text,
    link,
    logoSrc,
    onClick,
    hasPopup,
    ariaOwns,
    ariaLabel,
    icon: IconInput,
    iconProps: IconInputProps,
    dataUit,
    dataCmsTargetKey,
    hidden,
    iconButtonSx,
    clickHandlerOverride,
    popoverTarget,
    buttonId,
    hrefLang,
  } = props;

  const iconSx = {
    fontSize: "2.4rem",
  };

  const Icon = useMemo(() => {
    if (IconInput) {
      return <IconInput sx={iconSx} {...IconInputProps} />;
    }
    return <IconSrcToMuiMapper src={logoSrc} consumer={`component=HeaderButton text=${text}`} iconSx={iconSx} />;
  }, [logoSrc, IconInput]);

  const href = resolveUrl(link);
  return (
    <BNBox
      sx={{
        fontSize: "1.2rem",
        [theme.breakpoints.down("md")]: {
          display: hidden?.mdDown ? "none" : undefined,
        },
        [theme.breakpoints.up("md")]: {
          display: hidden?.mdUp ? "none" : undefined,
        },
      }}
    >
      <IconButton
        id={buttonId}
        aria-haspopup={hasPopup ? "true" : "false"}
        aria-owns={ariaOwns}
        aria-label={ariaLabel}
        data-uit={dataUit || `header-button-${buttonId}`}
        data-cms-target-key={dataCmsTargetKey}
        {...(href ? ({ href } as { href: string }) : {})}
        {...(hrefLang ? ({ hrefLang } as { hrefLang: string }) : {})}
        {...(popoverTarget ? ({ popoverTarget } as { popoverTarget: string }) : {})}
        onClick={
          clickHandlerOverride === null
            ? undefined
            : (event) => {
                // In case of regular spa pages, tracking and navigation happens bellow by js
                event.preventDefault();
                if (["konto", "Varsel", "Hjelp"].some((word) => text!.includes(word))) {
                  BNGoogleTagManager.addEventToDataLayer(
                    new UiElementClickEvent(EventAction.Header, EventLabel.Settings + ":" + text),
                  );
                }
                {
                  onClick?.(event);
                }
                if (props.link) {
                  if (props.isSpa && navigate) {
                    void navigate(props.link);
                  } else {
                    window.location.href = props.link;
                  }
                }
              }
        }
        sx={[
          {
            color: "inherit",
            fontSize: "1.2rem",
          },
          ...sxEnsureArray(iconButtonSx),
        ]}
      >
        <BNStack
          direction={"column"}
          sx={{
            justifyContent: "center",
            alignItems: "center",
            lineHeight: "normal",
          }}
        >
          <BNBox sx={{ textAlign: "center", height: "2.4rem", width: "2.4rem" }}>{Icon}</BNBox>
          <BNBox sx={{ whiteSpace: "nowrap" }}>{text}</BNBox>
        </BNStack>
      </IconButton>
    </BNBox>
  );
};
export default HeaderButton;
